import { lazy } from "react";
import { Outlet } from "react-router";
import { withPageLoader } from "@tecorien/mimic";
import { AuthorizationContextProvider } from "components/AuthorizationContextProvider";
import { SiteLayout } from "components/layouts/SiteLayout";
import { UserProfileChecker } from "components/UserProfileChecker";
import { UserSettingsProvider } from "components/UserSettingsProvider";
import { links } from "links";
import { RouteDescription } from "types";
import { KeycloakProvider } from "../../keycloak";
import { driverProfileRoutes } from "./driverProfiles";
import { exportFilesRoutes } from "./ExportFilesPage";
import { fileRequestsRoutes } from "./FileRequestsPage";
import { fleetsRoutes } from "./fleets";
import { generateFileRoutes } from "./generateFile";
import { lopRoutes } from "./LOP";
import { tagCategoriesRoutes } from "./tagCategories";
import { tagsRoutes } from "./tags";
import { verificationTypesRoutes } from "./verificationTypes";

const NotFoundPage = lazy(() => import("../system/NotFoundPage"));
const AccessDeniedPage = lazy(() => import("../system/AccessDeniedPage"));

const HomePage = lazy(() => import("./Home"));

export const appRoutes: RouteDescription[] = [
  {
    path: links.appRoot,
    element: (
      <KeycloakProvider>
        <AuthorizationContextProvider>
          <UserSettingsProvider>
            <SiteLayout>
              <UserProfileChecker>
                <Outlet />
              </UserProfileChecker>
            </SiteLayout>
          </UserSettingsProvider>
        </AuthorizationContextProvider>
      </KeycloakProvider>
    ),
    breadcrumb: "Home",
    children: [
      ...driverProfileRoutes,
      ...fleetsRoutes,
      ...exportFilesRoutes,
      ...fileRequestsRoutes,
      ...tagsRoutes,
      ...tagCategoriesRoutes,
      ...verificationTypesRoutes,
      ...generateFileRoutes,
      ...lopRoutes,
      {
        path: links.accessDenied,
        element: withPageLoader(<AccessDeniedPage />),
      },
      {
        path: "*",
        element: withPageLoader(<NotFoundPage />),
      },
      {
        index: true,
        element: withPageLoader(<HomePage />),
      },
    ],
  },
];
